import { useState } from 'react'

export interface UseErrorBoundaryReturn {
  error: Error | null
  handleError: (error: Error) => void
  resetError: () => void
}

export function useErrorBoundary(): UseErrorBoundaryReturn {
  const [error, setError] = useState<Error | null>(null)

  const resetError = () => {
    setError(null)
  }

  const handleError = (error: Error) => {
    setError(error)
  }

  return { error, handleError, resetError }
}
